module.exports = __webpack_public_path__ + "static/media/Cardo-Bold.d2197cd8.woff";